import React from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import ContactSection from "../../components/ContactSection";
import AboutSection from "./sections/AboutUI.js";
import WhatsappBTN from "../../components/WhatsappBTN";
const About = () => {
  return (
    <>
      <WhatsappBTN />
      <Header />
      <AboutSection />
      <ContactSection />
      <Footer />
    </>
  );
};

export default About;
